(function (sophiaWebsterView, $) {
  var shoeGraphic;
  var handwritingGraphic;
  var sophiaWebsterSection;
  var sophiaWebsterSectionHeight;
  var sophiaWebsterSectionOffsetTop;

  var isTouchEvent = Modernizr.touchevents;

  sophiaWebsterView.init = function () {
    handwritingGraphic = $("#sophia-webster-handwriting-link");
    shoeGraphic = $("#sophia-webster-lola-gem-shoe");

    sophiaWebsterSection = $("#sophia-webster-section");
    if (sophiaWebsterSection.length <= 0) {
      return;
    }

    calculateGeometry();
    setTimeout(calculateGeometry, 2000);
    setTimeout(calculateGeometry, 6000);
    setInterval(calculateGeometry, 18000);

    wireEvents();
  };

  function wireEvents() {
    el.documentElement.on("WINDOW_RESIZED_EVENT", function () {
      calculateGeometry();
    });

    if (!isTouchEvent) {
      el.documentElement.on("WINDOW_SCROLL_EVENT", function (evt, windowScrollTop) {
        var sectionOffset = windowScrollTop - sophiaWebsterSectionOffsetTop + el.windowHeight;

        if (el.windowWidth < 768 || sectionOffset < 0 || sectionOffset > sophiaWebsterSectionHeight * 2) {
          shoeGraphic.transit({ y: 0 }, 0, "linear");
          return;
        }

        var offsetBeyondBottomOfSection =
          windowScrollTop + el.windowHeight - sophiaWebsterSectionOffsetTop - sophiaWebsterSectionHeight;

        var distanceBeforeAnimStart = 90;
        if (offsetBeyondBottomOfSection > distanceBeforeAnimStart) {
          handwritingGraphic.transit(
            {
              y: (offsetBeyondBottomOfSection - distanceBeforeAnimStart) / 1.8,
              opacity: 1.2 - offsetBeyondBottomOfSection / 260,
            },
            0,
            "linear",
          );
          shoeGraphic.transit({ y: (offsetBeyondBottomOfSection - distanceBeforeAnimStart) / 1.2 }, 0, "linear");
        } else {
          handwritingGraphic.transit({ y: 0, opacity: 1 }, 0, "linear");
          shoeGraphic.transit({ y: 0 }, 0, "linear");
        }
      });
    }
  }

  function calculateGeometry() {
    if (el.windowWidth >= 768) {
      sophiaWebsterSectionHeight = sophiaWebsterSection.height();
      sophiaWebsterSectionOffsetTop = sophiaWebsterSection.offset().top;
    }
  }
})((window.el.SophiaWebsterView = window.el.SophiaWebsterView || {}), jQuery);
